export interface ContainerType {
    code: string;
    description: string;
    width: string;
    height: string;
}
